import { createContext, useContext, useMemo, useState } from 'react';

interface OpenVehicleListContextType {
    listOpen: boolean;
    setListOpen: (listOpen: boolean) => void;
}

export const OpenVehicleListContext = createContext<OpenVehicleListContextType>(
    {
        listOpen: false,
        setListOpen: () => {},
    },
);
export const useVehicleListOpen = () => useContext(OpenVehicleListContext);

export function VehicleListOpenProvider(p: { children: React.ReactNode }) {
    const [listOpen, setListOpen] = useState(false);
    const openVehicleListContextValue = useMemo(
        () => ({ listOpen, setListOpen }),
        [listOpen],
    );

    return (
        <OpenVehicleListContext.Provider value={openVehicleListContextValue}>
            {p.children}
        </OpenVehicleListContext.Provider>
    );
}
